import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function VoiceCallLogList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "from_number", sortable: false, label: "From number" },
        { key: "to_number", sortable: false, label: "to number" },
        { key: "date", sortable: false, label: "Date" },
        { key: "time", sortable: false, label: "Time" },
        { key: "person_email", sortable: false, label: "Email" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalVoiceCallLogList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const voiceCallLogsMetaData = ref([]);
    const voiceCallLogStatusOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalVoiceCallLogList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData();
    });

    const fetchVoiceCallLogList = (ctx, callback) => {
        store
            .dispatch("app-voice-call-logs/fetchVoiceCallLogs", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value
            })
            .then(response => {
                const voice_call_log = response.data.data;
                const { total } = response.data.meta;
                voiceCallLogStatusOption.value = response.data.status;

                callback(voice_call_log);
                totalVoiceCallLogList.value = total;
                voiceCallLogsMetaData.value = voice_call_log;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching voice-call-logs",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });

                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching voice-call-logs`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == false) return "danger";
        if (status == true) return "success";
        return "primary";
    };

    return {
        fetchVoiceCallLogList,
        tableColumns,
        perPage,
        currentPage,
        totalVoiceCallLogList,
        voiceCallLogsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        voiceCallLogStatusOption,
        statusFilter
    };
}
